import {type StyleProp, type ViewStyle} from 'react-native'
import {type AppBskyFeedDefs, type ModerationDecision} from '@atproto/api'

import {type DocumentMaterialRef} from '#/lib/document/material'
import {type DocumentAudience} from '#/lib/document/types'

export enum PostEmbedViewContext {
  ThreadHighlighted = 'ThreadHighlighted',
  Feed = 'Feed',
  FeedEmbedRecordWithMedia = 'FeedEmbedRecordWithMedia',
  ChatMessage = 'ChatMessage',
}

export type CommonProps = {
  moderation?: ModerationDecision
  onOpen?: () => void
  style?: StyleProp<ViewStyle>
  viewContext?: PostEmbedViewContext
  isWithinQuote?: boolean
  allowNestedQuotes?: boolean
  authorDid?: string
  /**
   * Who a document embed was published for. It lives on the post's *record*,
   * which the served embed view does not carry, so every surface that has it
   * hands it down — see `documentAudienceFromPost`.
   */
  documentAudience?: DocumentAudience
  /**
   * Where a document's page material lives, and what each page holds — the same
   * bargain as the audience above: it is on the post's record, not in the served
   * view, so the surface that has the record hands it down (see
   * `materialRefFromRecord`) and every badge is drawn without a request.
   */
  documentMaterial?: DocumentMaterialRef
  /**
   * The post this embed belongs to.
   *
   * One thing needs it and nothing else can supply it: a play's results are
   * attributed to the *post*, and an embed is handed its document but never the
   * post it was quoted into.
   */
  postUri?: string
}

export type EmbedProps = CommonProps & {
  embed?: AppBskyFeedDefs.PostView['embed']
}
